module.exports = __webpack_public_path__ + "img/marvelous-logo-color-coral.8163239a.svg";